export function frequencyToMidi(frequency: number) {
  return 69 + 12 * Math.log2(frequency / 440);
}

export function octaveInvariantDistance(actual: number, target: number) {
  const normalized = ((actual - target + 6) % 12 + 12) % 12 - 6;
  return Math.abs(normalized);
}

export function detectPitch(buffer: Float32Array, sampleRate: number): number | null {
  let rms = 0;
  for (const sample of buffer) rms += sample * sample;
  rms = Math.sqrt(rms / buffer.length);
  if (rms < 0.012) return null;

  const minLag = Math.floor(sampleRate / 1000);
  const maxLag = Math.min(Math.floor(sampleRate / 70), buffer.length - 1);
  let bestLag = -1;
  let bestCorrelation = 0;
  for (let lag = minLag; lag <= maxLag; lag += 1) {
    let correlation = 0;
    let normA = 0;
    let normB = 0;
    for (let index = 0; index < buffer.length - lag; index += 1) {
      const a = buffer[index] ?? 0;
      const b = buffer[index + lag] ?? 0;
      correlation += a * b;
      normA += a * a;
      normB += b * b;
    }
    const normalized = correlation / Math.sqrt(normA * normB || 1);
    if (normalized > bestCorrelation) {
      bestCorrelation = normalized;
      bestLag = lag;
    }
  }
  return bestLag > 0 && bestCorrelation > 0.72 ? sampleRate / bestLag : null;
}
